import type { FC } from "react"
import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material"
import ConstructionIcon from "@mui/icons-material/Construction"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  setAutoModelCheckStep,
  setStartAutoModelCheck,
  setCurArch,
  setOpenBiteReg,
  setOpenRelabel,
  setOpenSpaceCorrection,
  setOpenOrientation,
  setStageShowType,
  setOpenLiteMode,
  setZoomDisabled,
  setCurLeftPage,
  setReuploadSelfPlan,
  setOpenBiteCheck,
  setOpenCollisionCheck,
} from "@/UDTreat/udTreatSlice"
import {
  viewControlInTreatment,
  wasmModule,
  caseManagement,
  EArchType,
  relabel,
  toothMovement,
  resourcesSynchronization,
  refinement,
  spaceCorrection,
  displayModule,
} from "@/gluelayer"
//import { relabelModule } from "@/gluelayer/core/modules/relabel"
import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"
import {
  fetchZipsFromCacheOrRemote,
  uploadCaseZips,
  uploadCaseFilesByFileNames,
} from "@/core/app/slices/clinical/clinicalThunkApi"
import { useParams } from "react-router-dom"
import {
  setIsShowProgress,
  setProgressMsg,
} from "@/core/app/slices/clinical/clinicalSlice"
import NextIcon from "@mui/icons-material/KeyboardArrowRight"
import BackIcon from "@mui/icons-material/KeyboardArrowLeft"
import SikpIcon from "@mui/icons-material/LastPage"

import AutoModelCheck from "./AutoModelCheck"
import ResegmentTools from "./ResegmentTools"
import RelabelTools from "./RelabelTools"
import SpaceCorrectTools from "./SpaceCorrectTools"
import RegistrationTools from "./RegistrationTools"
import OrientationTools from "./OrientationTools"
import {
  fetchPhotosInModelCheck,
  uploadModelCheckZips,
} from "./modelCheckSlice"
import ReuploadForSelfPlan from "@/UDTreat/components/ReuploadForSelfPlan"
import { biteregModule } from "@/gluelayer/core/modules/bitereg/biteregModule"
const AutoModelCheckStep: FC<{ uploadAllData; lockFunc }> = ({
  uploadAllData,
  lockFunc,
}) => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  const {
    autoModelCheckStep: autoProActiveStep,
    curArch,
    openBiteReg,
    singleArchBool,
    curLeftPage,
    openBiteCheck,
    openCollisionCheck,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const {
    clinicalSettings: { NumberSystem },
  } = useAppSelector((state: RootState) => state.userService)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { uassist_round } = caseDetail
  const { caseId, patientId } = useParams()
  const [sameLabelDlg, setSameLabelDlg] = useState(false)
  const { setstageShowTypeNormalCallback } = relabel
  const [showSaveButton, setShowSaveButton] = useState(false)

  const onClickResegAddATooth = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.AddATooth()
  }

  const onClickResegRemoveATooth = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.RemoveATooth()
  }

  const onClickResegPaint = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.StartPaint()
  }

  const onClickResegDragEdge = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.StartDragEdge()
  }

  const onClickResegUndo = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.Undo()
  }

  const onClickResegReset = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    //resegmentationModule.Undo()
  }

  const onClickResegIdel = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    resegmentationModule.CancelOperation()
  }

  const onClickRelabelReset = () => {
    if (!resegmentationModule.isResegmentationModuleOpened()) return
    if (!resegmentationModule.isRelabelModuleOpened()) return

    resegmentationModule.ResetRelabel()
  }

  const onClickSpaceCorrectlReset = () => {
    if (wasmModule.moduleManager.GetSpaceCorrectionModule() !== null) {
    }
  }

  const onClickBiteUndo = () => {
    const biteModule = wasmModule.moduleManager.GetModuleBiteReg()
    if (biteModule) {
      biteModule.Undo()
    }
  }

  const onClickBiteReset = () => {
    const biteModule = wasmModule.moduleManager.GetModuleBiteReg()
    if (biteModule) {
      biteModule.Reset()
    }
  }

  const onGotoResegmentationRelabelCallback = () => {}

  useEffect(() => {
    resegmentationModule.setGotoResegmentationRelabelCallback =
      onGotoResegmentationRelabelCallback
    //resegmentationModule.setResegmentationRelabelFinishCallback =onResegmentationRelabelFinishCallback

    // close occlusion and spacecheck in auto model check
    viewControlInTreatment.setOcclusionVisibility(false)
    viewControlInTreatment.setSpacecheckVisibility(false)
  }, [])

  const handleNext = async (skip: boolean) => {
    dispatch(setZoomDisabled(false))

    if (resegmentationModule.isRelabelModuleOpened()) {
      console.log("Relabel module is opened")
      if (
        resegmentationModule.IsExistSameLabelForSingleJaw(0) ||
        resegmentationModule.IsExistSameLabelForSingleJaw(1)
      ) {
        setSameLabelDlg(true)
        return
      }

      dispatch(setProgressMsg("post process ..."))
      dispatch(setIsShowProgress(true))

      await resegmentationModule.CloseRelabel()

      /*if (relabelModule.IsRelabelModuleOpened()) {
        dispatch(setIsShowProgress(true))

        // 这是做了更改后需要和服务器交互等待时间
        setstageShowTypeNormalCallback(() => {
          // dispatch(setStageShowType("normal"))
          dispatch(setIsShowProgress(false))

          if (!skip) dispatch(setAutoModelCheckStep(autoProActiveStep + 1))
        })
      } else {
        if (!skip)
          if (singleArchBool && autoProActiveStep === 1) {
            // if is single arch, skip bite reg step
            dispatch(setAutoModelCheckStep(autoProActiveStep + 2))
          } else {
            dispatch(setAutoModelCheckStep(autoProActiveStep + 1))
          }
      }
      */
      if (!skip) {
        dispatch(setIsShowProgress(false))
        dispatch(setAutoModelCheckStep(singleArchBool ? 3 : 2))
        return
      }
    }
    dispatch(setProgressMsg("post process ..."))
    dispatch(setIsShowProgress(true))

    if (
      skip &&
      resegmentationModule.isResegmentationModuleOpened() &&
      resegmentationModule.isRelabelModuleOpened() == false
    ) {
      //skip in resegmentation

      await resegmentationModule.openResegmentationModule(false)
    }

    await closeFunctions()
    dispatch(setIsShowProgress(false))
    if (autoProActiveStep < 4 && !skip) {
      // if is single arch, skip bite reg step
      if (singleArchBool && autoProActiveStep === 1) {
        dispatch(setAutoModelCheckStep(autoProActiveStep + 2))
        return
      }

      dispatch(setAutoModelCheckStep(autoProActiveStep + 1))
    }
    if (autoProActiveStep === 4 || skip) {
      // finish
      dispatch(setStartAutoModelCheck(false))
      dispatch(setStageShowType("normal"))
      dispatch(setCurArch("all"))
      // upload changed zips
      dispatch(uploadModelCheckZips({ patientId, caseId }))
    }
  }
  const handleBack = () => {
    dispatch(setZoomDisabled(false))

    if (resegmentationModule.isResegmentationModuleOpened()) {
      console.log("Relabel module is opened")
      if (
        resegmentationModule.IsExistSameLabelForSingleJaw(0) ||
        resegmentationModule.IsExistSameLabelForSingleJaw(1)
      ) {
        setSameLabelDlg(true)
        return
      }

      resegmentationModule.CancelAndExitRelabel()
      dispatch(setAutoModelCheckStep(autoProActiveStep - 1))
      dispatch(setIsShowProgress(false))

      /*
      relabelModule.openRelabelModule(false)
      if (relabelModule.IsRelabelModuleOpened()) {
        dispatch(setIsShowProgress(true))

        // 这是做了更改后需要和服务器交互等待时间
        setstageShowTypeNormalCallback(() => {
          // dispatch(setStageShowType("normal"))
          dispatch(setAutoModelCheckStep(autoProActiveStep - 1))
          dispatch(setIsShowProgress(false))
        })
      } else {
        dispatch(setAutoModelCheckStep(autoProActiveStep - 1))
      }
      */

      return
    }
    closeFunctions()

    if (autoProActiveStep > 0) {
      // if is single arch, skip bite reg step
      if (singleArchBool && autoProActiveStep === 3) {
        dispatch(setAutoModelCheckStep(autoProActiveStep - 2))
      } else {
        dispatch(setAutoModelCheckStep(autoProActiveStep - 1))
      }
    }
  }

  const closeFunctions = async () => {
    if (wasmModule.moduleManager.GetModuleOrientationAdjustment() !== null) {
      console.log("SwitchModuleOrientationAdjustment(false)")
      wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
      // dispatch(setStageShowType("normal"))
    }
    if (wasmModule.moduleManager.GetSpaceCorrectionModule() !== null) {
      console.log("ToggleSpaceCorrect(false)")
      spaceCorrection.openSpaceCorrectionModule(false)
      dispatch(setOpenSpaceCorrection(false))
      // dispatch(setStageShowType("normal"))
    }
    if (resegmentationModule.isRelabelModuleOpened()) {
      console.log("resegmentationModule.openResegmentationModule(false)")
      await resegmentationModule.openResegmentationModule(false)
      // dispatch(setStageShowType("normal"))
    }
    if (openBiteReg) {
      await biteregModule.SaveData()
      dispatch(setOpenBiteReg(false))
      // dispatch(setStageShowType("normal"))
    }

    dispatch(setCurArch("all"))
    viewControlInTreatment.setViewType("front")
    setShowSaveButton(false)
    dispatch(setCurLeftPage(""))

    // setTitle("")
  }

  //缓存上一个curArch状态
  const prevCurArchRef = useRef<string>(curArch)
  useEffect(() => {
    // 在"Spacing"或者"segemention"||"lable"中，如果当前是"all"模式，则还是保持原来的上下颌模式
    if (
      (autoProActiveStep == 0 ||
        autoProActiveStep == 1 ||
        autoProActiveStep == 3) &&
      curArch === "all"
    ) {
      dispatch(setCurArch(prevCurArchRef.current))
    }
    prevCurArchRef.current = curArch
  }, [curArch])

  const spaceApplyStatusCallback = (isPending: number) => {
    if (isPending === 1) {
      dispatch(setProgressMsg("Space Progressing"))
      dispatch(setIsShowProgress(true))
      setTimeout(() => {
        spaceCorrection.pendingApplyEditValue()
      }, 50)
    } else {
      dispatch(setIsShowProgress(false))
    }
  }

  const checkDownloadSettingData0 = async (): Promise<boolean> => {
    const files: Record<string, Record<string, File>> = {}
    files["Setting Data0"] =
      await resourcesSynchronization.getFileListFromVirtualFS("Setting Data0")
    const zipKeys = Object.keys(files["Setting Data0"])
    if (zipKeys.length === 0) {
      try {
        const bulk0Zip: Record<string, any> = {}
        async function retryRequest(retriesLeft, delay) {
          const ret: any = await dispatch(
            fetchZipsFromCacheOrRemote({
              caseId,
              patientId,
              zipNames: ["bulk0"],
              isDownloadRetouchHistory: false,
            }),
          ).unwrap()

          const keys = Object.keys(ret)
          let findBulk0 = false
          for (const key of keys) {
            if (key === "bulk0.zip") {
              bulk0Zip[key] = ret[key]
              findBulk0 = true
              break
            }
          }

          if (!findBulk0) {
            if (retriesLeft > 0) {
              console.error("Retrying to download sd10...", retriesLeft)

              await new Promise((resolve) => setTimeout(resolve, delay))
              return retryRequest(retriesLeft - 1, delay)
            } else {
              console.log("Not downloaded to bulk0.zip")
              return findBulk0
            }
          }
          return findBulk0
        }

        const findBulk0 = await retryRequest(3, 1000)
        if (findBulk0) {
          await resourcesSynchronization.writeCaseFilesToVirtualFS(bulk0Zip)
          files["Setting Data0"] =
            await resourcesSynchronization.getFileListFromVirtualFS(
              "Setting Data0",
            )
          const zipKeys = Object.keys(files["Setting Data0"])
          if (zipKeys.length === 0) {
            console.log(
              "Segmentation: After downloading and unzipping, there are no files in Setting Data0",
            )
            return false
          }
          wasmModule.statusController.InitSettingData0FoldersSHA()
        } else {
          return false
        }
      } catch (error) {
        console.log("Segmentation error : ", error)
        return false
      }
    }

    return true
  }

  useEffect(() => {
    console.log("autoProActiveStep", autoProActiveStep)

    if (!wasmModule.isFinishedOpencase) return

    toothMovement.setIsEnableMoveTooth(false)
    dispatch(setOpenLiteMode(true))

    switch (autoProActiveStep) {
      case 0:
        console.log("Segmentation")
        const seg = async () => {
          const downloadData0Res: boolean = await checkDownloadSettingData0()
          if (!downloadData0Res) return

          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          await dispatch(setCurArch(hasUpper ? "up" : "low"))
          viewControlInTreatment.showArchMode(hasUpper ? "up" : "low")
          resegmentationModule.numberSystem = NumberSystem
          await resegmentationModule.openResegmentationModule(true)

          // disable hover tooth in auto model check
          wasmModule.moduleManager.SwitchModulePropOnHover(false)
          console.log("resegmentationModule is already opened")
        }

        if (resegmentationModule.isResegmentationModuleOpened()) {
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          dispatch(setCurArch(hasUpper ? "up" : "low"))
        } else {
          seg()
        }

        break
      case 1:
        if (resegmentationModule.isRelabelModuleOpened()) {
          if (
            resegmentationModule.IsExistSameLabelForSingleJaw(0) ||
            resegmentationModule.IsExistSameLabelForSingleJaw(1)
          ) {
            console.log("Same label exists")
            return
          }
        }

        const relabel = async () => {
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          await dispatch(setCurArch(hasUpper ? "up" : "low"))

          if (resegmentationModule.isResegmentationModuleOpened() == false) {
            resegmentationModule.numberSystem = NumberSystem
            await resegmentationModule.openResegmentationModule(true)
          }

          viewControlInTreatment.zoomWithValueInTreatment(1)
          //if (wasmModule.moduleManager.GetSplitScreenModule() === null) {
          //if (curArch === "all") await dispatch(setCurArch("up"))
          //}
          // const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          // const hasLower = wasmModule.getArchModel(EArchType.LowArch)
          // if (hasUpper && hasLower) {
          //   viewControlInTreatment.showArchMode("all")
          //   wasmModule.statusController.SplitScreenDisplay(false)
          //   viewControlInTreatment.showArchMode("up")
          //   await dispatch(setCurArch("up"))
          // } else {
          //   await dispatch(setCurArch(hasUpper ? "up" : "low"))
          // }
          //if (curArch === "all") await dispatch(setCurArch("up"))
          //resegmentationModule.numberSystem = NumberSystem
          resegmentationModule.GotoRelabel()
          if ((window as any).pulloutCallback()) {
            ;(window as any).pulloutCallback()
          }
          // await dispatch(setStageShowType(""))

          /*if (relabelModule.IsRelabelModuleOpened()) {
            await dispatch(setOpenRelabel(true))
            if ((window as any).treatment.RelabelViewZoomCallback) {
              ;(window as any).treatment.RelabelViewZoomCallback(
                relabelModule.zoomValue,
              )
            }
          }*/
        }

        relabel()
        dispatch(setZoomDisabled(true))
        break
      case 2:
        dispatch(setOpenBiteReg(true))
        dispatch(
          fetchPhotosInModelCheck({
            patientId,
            caseId,
            refinementIndex: uassist_round,
          }),
        )
        break
      case 3:
        dispatch(setStageShowType(""))
        const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
        dispatch(setCurArch(hasUpper ? "up" : "low"))

        spaceCorrection.openSpaceCorrectionModule(true)
        spaceCorrection.setApplyStatusCallback(spaceApplyStatusCallback)
        dispatch(setOpenSpaceCorrection(true))
        break
      case 4:
        dispatch(setZoomDisabled(true))
        dispatch(setOpenOrientation(true))
        setShowSaveButton(true)
        viewControlInTreatment.setViewType("front")
        wasmModule.moduleManager.SwitchModuleOrientationAdjustment(true)
        dispatch(
          fetchPhotosInModelCheck({
            patientId,
            caseId,
            refinementIndex: uassist_round,
          }),
        )
        if (singleArchBool) {
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          dispatch(setCurArch(hasUpper ? "up" : "low"))
        } else {
          dispatch(setCurArch("all"))
        }
        break
      default:
    }
    viewControlInTreatment.hoverToothToggle(false)
  }, [autoProActiveStep])

  useEffect(() => {
    if (autoProActiveStep !== 4) return
    const oriModule = wasmModule.moduleManager.GetModuleOrientationAdjustment()
    oriModule && oriModule.ShowPhotoPanel(curLeftPage === "records")
  }, [curLeftPage, autoProActiveStep])

  useLayoutEffect(() => {
    return () => {
      console.log("unmount AutoModelCheckStep")
      toothMovement.setIsEnableMoveTooth(true)
      dispatch(setOpenLiteMode(false))
      dispatch(setAutoModelCheckStep(0))
    }
  }, [])
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "40px",
          position: "absolute",
          bottom: "5%",
          // background: "red",
          display: "flex",
          justifyContent: "center",
          gap: "40px",
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          {/* <Button
            // disabled={autoProActiveStep === 0}
            onClick={async () => {
              dispatch(
                setReuploadSelfPlan({
                  isReuploadSelfPlan: true,
                  onConfirm: async () => {
                    // close auto model check
                    closeFunctions()
                    dispatch(setStartAutoModelCheck(false))
                    dispatch(setStageShowType("normal"))
                  },
                }),
              )
            }}
            sx={{
              width: "181px",
              height: "42px",
              padding: "8px 22px",
              backgroundColor: "#E0E0E0",
              color: "rgba(0, 0, 0, 0.87)",
              borderRadius: "4px",
              fontWeight: 500,
              boxShadow:
                "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",

              "&:hover": {
                backgroundColor: "#E0E0E0",
                opacity: 0.8,
                boxShadow:
                  "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
              },
            }}
            // variant="contained"
          >
            {"REUPLOAD SCANS"}
          </Button> */}
          <Button
            disabled={autoProActiveStep === 0}
            onClick={handleBack}
            sx={{
              width: "109px",
              height: "42px",
              padding: "22px",
              borderRadius: "4px",
            }}
            variant="contained"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <BackIcon sx={{ width: 24, height: 24 }} />
              <Typography fontSize={15} fontWeight={500}>
                Back
              </Typography>
            </Stack>
          </Button>
        </Stack>

        <AutoModelCheck />

        <Stack direction="row" spacing={2} alignItems="center">
          <Button
            onClick={() => handleNext(false)}
            sx={{
              width: "109px",
              height: "42px",
              padding: "22px",
              borderRadius: "4px",
            }}
            variant="contained"
          >
            {autoProActiveStep === 4 ? (
              "Finish"
            ) : (
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography fontSize={15} fontWeight={500}>
                  Next
                </Typography>
                <NextIcon sx={{ width: 24, height: 24 }} />
              </Stack>
            )}
          </Button>

          <Button
            onClick={() => handleNext(true)}
            sx={{
              width: "103px",
              height: "42px",
              padding: "8px 22px",
              color: "rgba(0, 0, 0, 0.87)",
              borderRadius: "4px",
              background: "var(--grey-300, #E0E0E0)",
              boxShadow:
                "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",

              "&:hover": {
                backgroundColor: "#E0E0E0",
                opacity: 0.8,
                boxShadow:
                  "0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)",
              },
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography fontSize={15} fontWeight={500}>
                Skip
              </Typography>
              <SikpIcon sx={{ width: 24, height: 24 }} />
            </Stack>
          </Button>
        </Stack>
      </Box>

      <Dialog open={sameLabelDlg}>
        <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
        <DialogContent>{"There are duplicates, please relabel!"}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSameLabelDlg(false)}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <ReuploadForSelfPlan lockFunc={lockFunc} />
      {/* {saveOrientationButton} */}

      {autoProActiveStep === 0 && (
        <ResegmentTools
          DoShowClose={false}
          ClickAddTooth={onClickResegAddATooth}
          ClickDelTooth={onClickResegRemoveATooth}
          ClickPaint={onClickResegPaint}
          ClickDrag={onClickResegDragEdge}
          ClickUndo={onClickResegUndo}
          ClickReset={onClickResegReset}
          ClickIdel={onClickResegIdel}
        />
      )}
      {autoProActiveStep === 1 && (
        <RelabelTools
          DoShowClose={false}
          // ClickAddTooth={onClickAddATooth}
          // ClickDelTooth={onClickRemoveATooth}
          // ClickPaint={handleClose}
          // ClickDrag={()=>setResegmentationItem("")}
          ClickReset={onClickRelabelReset}
          // ClickClose={ handleClick}
        />
      )}

      {autoProActiveStep === 2 && (
        <RegistrationTools
          DoShowClose={false}
          ClickUndo={onClickBiteUndo}
          ClickReset={onClickBiteReset}
        />
      )}

      {autoProActiveStep === 3 && (
        <SpaceCorrectTools
          DoShowClose={false}
          // ClickAddTooth={onClickAddATooth}
          // ClickDelTooth={onClickRemoveATooth}
          // ClickPaint={handleClose}
          // ClickDrag={()=>setResegmentationItem("")}
          //ClickUndo={onClickSpaceCorrectlReset}
          // ClickClose={ handleClick}
        />
      )}
      {autoProActiveStep === 4 && (
        <OrientationTools
          DoShowClose={false}
          // ClickAddTooth={onClickAddATooth}
          // ClickDelTooth={onClickRemoveATooth}
          // ClickPaint={handleClose}
          // ClickDrag={()=>setResegmentationItem("")}
          //ClickUndo={onClickSpaceCorrectlReset}
          // ClickClose={ handleClick}
        />
      )}
    </>
  )
}
export default AutoModelCheckStep
